import { Icon } from './Icon';
import { ICON_SIZE } from '../styles/tokens';
import { HEADER_SLOT_ID } from '../hooks/useHeaderSlot';
import { haptic } from '../lib/haptic';
import { playSfx } from '../lib/sfx';
import './Header.css';

type Props = {
  title: string;
  showBack: boolean;
  onBack: () => void;
  onHome: () => void;
  online: boolean;
};

export function Header({ title, showBack, onBack, onHome, online }: Props) {
  const handleBack = () => {
    haptic('light');
    playSfx('page');
    onBack();
  };

  const handleHome = () => {
    haptic('light');
    onHome();
  };

  return (
    <header className="header">
      <div className="header-left">
        {showBack && (
          <button
            type="button"
            className="icon-btn btn--primary"
            onClick={handleBack}
            aria-label="Volver"
          >
            <Icon name="arrow-left" size={ICON_SIZE.md} />
          </button>
        )}
        <button
          type="button"
          className="header-title tap hit"
          onClick={handleHome}
          aria-label="Inicio"
        >
          <span className="header-title-text">{title}</span>
        </button>
      </div>

      <div className="header-right">
        {/* Slot para acciones de la vista activa (ver useHeaderSlot) */}
        <div className="header-actions" id={HEADER_SLOT_ID} />
        {!online && (
          <span className="neo-badge neo-badge--orange" role="img" aria-label="Sin conexión">
            <Icon name="wifi-off" size={ICON_SIZE.sm} />
          </span>
        )}
      </div>
    </header>
  );
}
